@if (isLoading()) {
  <div class="flex items-center justify-center min-h-screen" style="background:#fafaf7">
    <div class="relative w-10 h-10">
      <div class="absolute inset-0 rounded-full border-4 border-stone-200"></div>
      <div class="absolute inset-0 rounded-full border-4 border-t-primary-400 animate-spin"></div>
    </div>
  </div>
}

@if (!isLoading()) {
  <div class="min-h-screen" style="background:#fafaf7">
    <div class="max-w-[800px] mx-auto px-5 sm:px-8 py-8 space-y-5">

      <!-- Back -->
      <button (click)="onBack()" class="flex items-center gap-2 text-stone-400 hover:text-primary-600 transition-colors">
        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"/>
        </svg>
        <span class="text-[11px] font-bold uppercase tracking-wider">Retour aux formulaires</span>
      </button>

      @if (errorMessage()) {
        <div class="p-4 rounded-2xl bg-red-50 border border-red-100 text-sm text-red-700">{{ errorMessage() }}</div>
      }

      @if (formulaire()) {
        <div class="bg-white rounded-2xl border border-stone-100 shadow-sm overflow-hidden">

          <!-- Header -->
          <div class="px-6 py-4 border-b border-stone-100 flex items-center gap-3">
            <div class="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0"
              style="background-color: #5998e5">
              <svg fill="white" viewBox="0 0 24 24" class="w-4 h-4">
                <path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
              </svg>
            </div>
            <div>
              <div class="flex items-center gap-2">
                <span class="text-[11px] font-mono bg-stone-100 px-2 py-0.5 rounded text-stone-600">{{ formulaire()!.formulaire_code }}</span>
                <h1 class="text-sm font-bold text-stone-800">{{ formulaire()!.formulaire_nom_fr }}</h1>
              </div>
              <p class="text-[11px] text-stone-400 mt-0.5">{{ formulaire()!.formulaire_type }}</p>
            </div>
          </div>

          <!-- Section 1: Info -->
          <div class="px-6 py-5 space-y-4">
            <p class="text-[10px] font-bold text-stone-400 uppercase tracking-widest">Informations</p>

            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div class="space-y-1.5">
                <label class="text-[11px] font-semibold text-stone-500">Nom (français)</label>
                <input type="text" [value]="editNomFr()" (input)="editNomFr.set($any($event.target).value)"
                  class="fiche-input w-full" autoDir />
              </div>
              <div class="space-y-1.5">
                <label class="text-[11px] font-semibold text-stone-500">Nom (arabe)</label>
                <input type="text" [value]="editNomAr()" (input)="editNomAr.set($any($event.target).value)"
                  class="fiche-input w-full" dir="rtl" />
              </div>
            </div>

            <div class="space-y-1.5">
              <label class="text-[11px] font-semibold text-stone-500">Statut</label>
              <div class="flex items-center gap-3">
                <label class="status-radio-label" [class.active]="editStatus() === 'ACTI'">
                  <input type="radio" name="f_status" value="ACTI" [checked]="editStatus() === 'ACTI'"
                    (change)="editStatus.set('ACTI')" class="hidden" />
                  <span class="w-2 h-2 rounded-full" [class]="editStatus() === 'ACTI' ? 'bg-emerald-500' : 'bg-stone-300'"></span>
                  Publié
                </label>
                <label class="status-radio-label" [class.active-inac]="editStatus() === 'INAC'">
                  <input type="radio" name="f_status" value="INAC" [checked]="editStatus() === 'INAC'"
                    (change)="editStatus.set('INAC')" class="hidden" />
                  <span class="w-2 h-2 rounded-full" [class]="editStatus() === 'INAC' ? 'bg-amber-400' : 'bg-stone-300'"></span>
                  Inactif
                </label>
              </div>
            </div>
          </div>

          <div class="border-t border-stone-100"></div>

          <!-- Section 2: Files -->
          <div class="px-6 py-5 space-y-3">
            <p class="text-[10px] font-bold text-stone-400 uppercase tracking-widest">Fichiers</p>

            <!-- PDF slot -->
            <div class="file-slot">
              <span class="file-slot-badge file-slot-pdf">PDF</span>
              <div class="flex-1 min-w-0">
                @if (pendingPdf()) {
                  <span class="text-sm text-amber-700 truncate block">{{ pendingPdf()!.name }}</span>
                  <span class="text-[10px] text-amber-500 font-semibold">En attente d'enregistrement</span>
                } @else if (pdfFile()) {
                  <span class="text-sm text-stone-700 truncate block">{{ pdfFile()!.file_name }}</span>
                } @else {
                  <span class="text-sm text-stone-400 italic">Aucun fichier</span>
                }
              </div>
              <div class="flex items-center gap-2 flex-shrink-0">
                @if (pendingPdf()) {
                  <button type="button" (click)="cancelPending('pdf')"
                    class="file-slot-btn text-stone-400 hover:text-stone-600">
                    <span class="material-icons text-[16px]">undo</span>
                  </button>
                } @else if (pdfFile()) {
                  <button type="button" (click)="clearFile('pdf')"
                    class="file-slot-btn text-stone-400 hover:text-red-500">
                    <span class="material-icons text-[16px]">clear</span>
                  </button>
                }
                <label class="file-slot-btn text-stone-400 hover:text-primary-600 cursor-pointer" title="Remplacer le fichier">
                  <span class="material-icons text-[16px]">upload</span>
                  <input type="file" accept=".pdf" class="hidden" (change)="onReupload('pdf', $event)" />
                </label>
              </div>
            </div>

            <!-- DOCX slot -->
            <div class="file-slot">
              <span class="file-slot-badge file-slot-docx">DOCX</span>
              <div class="flex-1 min-w-0">
                @if (pendingDocx()) {
                  <span class="text-sm text-amber-700 truncate block">{{ pendingDocx()!.name }}</span>
                  <span class="text-[10px] text-amber-500 font-semibold">En attente d'enregistrement</span>
                } @else if (docxFile()) {
                  <span class="text-sm text-stone-700 truncate block">{{ docxFile()!.file_name }}</span>
                } @else {
                  <span class="text-sm text-stone-400 italic">Aucun fichier</span>
                }
              </div>
              <div class="flex items-center gap-2 flex-shrink-0">
                @if (pendingDocx()) {
                  <button type="button" (click)="cancelPending('docx')"
                    class="file-slot-btn text-stone-400 hover:text-stone-600">
                    <span class="material-icons text-[16px]">undo</span>
                  </button>
                } @else if (docxFile()) {
                  <button type="button" (click)="clearFile('docx')"
                    class="file-slot-btn text-stone-400 hover:text-red-500">
                    <span class="material-icons text-[16px]">clear</span>
                  </button>
                }
                <label class="file-slot-btn text-stone-400 hover:text-primary-600 cursor-pointer" title="Remplacer le fichier">
                  <span class="material-icons text-[16px]">upload</span>
                  <input type="file" accept=".docx" class="hidden" (change)="onReupload('docx', $event)" />
                </label>
              </div>
            </div>
          </div>

        </div>

        <!-- Save outside card -->
        <div class="flex justify-end">
          <button type="button" (click)="saveChanges()" [disabled]="isSaving() || !editNomFr().trim()"
            class="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-600 text-white text-sm font-semibold rounded-xl hover:bg-primary-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors shadow-sm">
            @if (isSaving()) {
              <div class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            } @else {
              <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5"/>
              </svg>
            }
            {{ isSaving() ? 'Enregistrement…' : 'Enregistrer' }}
          </button>
        </div>
      }

    </div>
  </div>
}
